import React, {
    createContext,
    useContext,
    useEffect,
    useRef,
    useState,
} from "react";
import {
    HubConnectionBuilder,
    LogLevel,
    HttpTransportType,
} from "@microsoft/signalr";
import * as url from "../../api/uri_helper";
import { useSelector } from 'react-redux';

const SignalRContext = createContext();

const callType = {
    LiveChat: 'LiveChat',
    Audio: 'Audio',
    Video: 'Video',
    Email: 'Email',
    Whatsapp: 'Whatsapp',
    SMS: 'SMS'
  };
export const SignalRProvider = ({ children, emailid }) => {
    const [roomdata, setRoomData] = useState(null);
    const [connected, setConnected] = useState(false);
    const [connectionId, setConnectionId] = useState(null);
    const [connection, setConnection] = useState(null);
    // const loggedInEmailId = localStorage.getItem("emailid");
    const [isInCall, setIsInCall] = useState(false);
    const [receiverId, setReceiverId] = useState("");
    const [callerFullName, setCallerFullName] = useState("");
    const [Id, SetId] = useState("");
    const [incomingCallVisible, setIncomingCallVisible] = useState(false); // State to control the incoming call modal
    const [callingId, setCallingId] = useState(""); //save the generated connection id
    const [isCallAccepted, setIsCallAccepted] = useState(false);
    const [closeVideocallModal, setCloseVideocallModal] = useState(false);
    const [roomId, setRoomId] = useState("");
    // const [ICE_SERVERS, setICEServers] = useState({ iceServers: [] });
    const allUserTypes = useSelector((state) => state.allUserdata.users);
    const loginuserId = allUserTypes?.data?.userId;

    //Twillow Missed call state detector
    const [isMissed, setIsMissed] = useState(false);
    const [localStream, setLocalStream] = useState(null);
    // const [otherUserCameraStatus, setOtherUserCameraStatus] = useState(false);


    const loggedInAsUser = localStorage?.getItem("loginAsUser");
    //  const loggedInEmailId = loggedInAsUser ? loggedInAsUser : emailid ? emailid : localStorage.getItem("emailid");
    const loggedInUserId = localStorage.getItem("UserId");

    const [loggedInEmailId, setLoggedInEmailId] = useState(() => emailid || localStorage.getItem("emailid"));
    const [remoteMediaStatus, setRemoteMediaStatus] = useState({ audio: true, video: true })

    useEffect(() => {
        // Whenever loggedInUserId changes, update loggedInEmailId
        const newLoggedInEmailId = loggedInAsUser ? loggedInAsUser : emailid || localStorage.getItem("emailid");

        setLoggedInEmailId(newLoggedInEmailId);

    }, [loggedInUserId]);

    useEffect(() => {
        const handleMediaToggle = (mediaData) => {
            console.log('mediaData : ', mediaData)
            if(mediaData){
                setRemoteMediaStatus(mediaData)
            }
        };
        if (connection) {
            connection.on("CallRejected", () => {
                console.log("Call was rejected by the other user");

                // Stop media tracks and disconnect from the room
                if (roomdata) {
                    roomdata.localParticipant.tracks.forEach((trackPublication) => {
                        if (trackPublication.track) {
                            trackPublication.track.stop();
                            trackPublication.track.detach().forEach((el) => el.remove());
                        }
                    });
                    roomdata.disconnect();
                }

                // Cleanup UI
                setIsInCall(false);
                setIncomingCallVisible(false);
                closeVideocallModal();
                setIsCallAccepted(false);
            });
            connection.on('MediaToggle', handleMediaToggle);
        }
        
        // Cleanup event listener on unmount
        return () => {
            if (connection) {
                connection.off("CallRejected");
                connection.off("MediaToggle");
            }
        };
    }, [connection, roomdata]);
    useEffect(() => {
        // Ensure the connection is initialized before trying to use it
        if (connection) {
            connection.on('CallEnded', (message) => {
                // Handle call end on this side
                setIsInCall(false);
                closeVideocallModal();
                setIsCallAccepted(false);
                setIncomingCallVisible(false);
            });
        }

        // Cleanup the event listener when the component unmounts
        return () => {
            if (connection) {
                connection.off('CallEnded');
            }
        };
    }, [connection, roomdata]);

    useEffect(() => {
        if (emailid !== null && emailid !== "") {
            const connectToHub = async () => {
                const newConnection = new HubConnectionBuilder()
                    .withUrl(`${url.BASE}/CallHub?email=${loggedInEmailId}`, {
                        transport: HttpTransportType.WebSockets | HttpTransportType.LongPolling | HttpTransportType.ServerSentEvents,
                    })
                    .configureLogging(LogLevel.Information)
                    .withAutomaticReconnect()
                    .build();

                // Connection lifecycle events
                newConnection.onreconnecting((error) => {
                    console.warn('Connection lost due to error. Reconnecting...', error);
                });

                newConnection.onreconnected((connectionId) => {
                    console.log('Reconnected successfully.');
                });

                newConnection.onclose((error) => {
                    console.error('Connection closed. Attempting to reconnect...', error);
                    connectToHub(); // Retry connection
                });

                try {
                    await newConnection.start();
                    setConnection(newConnection);
                    setConnectionId(newConnection.connectionId);
                    console.log('ConnectION ID ',newConnection.connectionId);
                    setConnected(true)
                } catch (error) {
                    console.error('Connection failed:', error);
                    setTimeout(() => connectToHub(), 2000); // Retry after delay
                }

                // Other SignalR event listeners
                newConnection.on('OnConnected', (connectionId) => {
                    setCallingId(connectionId);
                   // setConnectionId(connectionId);
                });

                newConnection.on('CallRequested', async (callerId, callerFullName, callerConnectionId) => {

                    if (callerId) {
                        setCallerFullName(callerFullName);
                        SetId(callerId);
                        setRoomId(callerConnectionId);
                        setIncomingCallVisible(true);

                        // await newConnection.invoke('RespondToCall', callerId, true);
                    } else {
                        await newConnection.invoke('RespondToCall', callerId, false);
                    }
                });
                newConnection.on("CallAccepted", (receiverConnectionId) => {
                    console.log("Call accepted by the other user");
                    setRoomId(receiverConnectionId); // Update room ID for caller when accepted
                    setIsCallAccepted(true);
                    setIsInCall(true)

                });

            };

            connectToHub();
        }
    }, [loggedInEmailId]);

    //intilize call
    const initiateCall = async () => {
        await connection.invoke('RequestCall', receiverId);
        console.log("call incoked to ", receiverId);
    };

    //reciever side      
    const acceptCall = async () => {
        try {
            setIsMissed(false)
            console.log(`While acccepting----- RoomId: ${roomId}, Id : ${Id}`)
            await connection.invoke("AcceptCall", roomId, Id);
            setIncomingCallVisible(false);
            setIsCallAccepted(true);
        } catch (error) {
            console.error("Error accepting call:", error);
        }

    };
    const endCall = async () => {
        const targetId = callingId;
        setIsInCall(false);
        setIsCallAccepted(false);
        setIncomingCallVisible(false);
        await connection.invoke('EndCall', targetId);
    };
    const handleCloseVideoCall = async () => {
        await endCall();

    };

    const rejectCall = async () => {
        rejectIncomingCall(Id);
    }
    const cancellCall = () => {
        connection.invoke('CancelCall', Id)
    }
    const rejectIncomingCall = async (callerId) => {
        setIsCallAccepted(false);
        try {
            await connection.invoke("RejectCall", callerId);
            setIncomingCallVisible(false);
            await handleCloseVideoCall();
            await closeVideocallModal();
            if (isMissed) {
                console.log("is Missed : ", isMissed);
                addMissedCallNotification(Id, callType.Video)
            }
            setIsMissed(false)
            setRemoteMediaStatus({video: true , audio: true })
        } catch (error) {
            console.error("Failed to reject the call:", error);
        }
    };
    const addMissedCallNotification = async (callerId, type) => {
        console.log('Entered in Add Miss Notification : ', isMissed)
        await connection.invoke("AddTwilioNotification", callerId, loggedInEmailId, type);
    }
    const togglevideoCallMedia = (remoteMediaStatus) => {
        const targetEmail = receiverId !== null && receiverId !== undefined && receiverId !== "" ? receiverId : Id;
        connection.invoke("ToggleMedia", targetEmail, remoteMediaStatus);
      };
    useEffect(()=>{
        console.log(remoteMediaStatus)
    },[])

    return (
        <SignalRContext.Provider value={{
            setIsCallAccepted, 
            roomId, 
            isCallAccepted, 
            setRoomData,
            callerFullName, 
            receiverId, 
            setReceiverId, 
            connectionId, 
            initiateCall, 
            connection, 
            connected, 
            acceptCall, 
            isInCall,
            setIsInCall,
            incomingCallVisible, 
            rejectCall, 
            setCloseVideocallModal, 
            setIsMissed, 
            isMissed,
            cancellCall,
            roomdata,
            localStream,
            setLocalStream,
            togglevideoCallMedia,
            setRemoteMediaStatus,
            remoteMediaStatus,
            endCall
         }}>
            {children}
        </SignalRContext.Provider>
    );
};

export const useSignalR = () => useContext(SignalRContext);